exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field.is-horizontal{display:flex}.field:not(:last-child){margin-bottom:10px}", ""]);

// exports
